import { Vote, CheckSquare, MessageSquare, Mail, Hash, Calendar } from 'lucide-react';
import { AnalyticsIcon } from '../icons';

export interface QuestionTemplate {
  id: string;
  name: string;
  description: string;
  icon: typeof Vote;
  type: 'short_text' | 'long_text' | 'single_select' | 'multi_select' | 'nps' | 'numeric' | 'date' | 'email';
  question: string;
  placeholder?: string;
  required: boolean;
  options?: { value: string; label: string }[];
}

export const QUESTION_TEMPLATES: QuestionTemplate[] = [
  {
    id: 'support-oppose',
    name: 'Support/Oppose',
    description: 'Constituent position on legislation',
    icon: Vote,
    type: 'single_select',
    question: 'Do you support or oppose this legislation?',
    required: true,
    options: [
      { value: 'support', label: 'Support' },
      { value: 'neutral', label: 'Neutral / Undecided' },
      { value: 'oppose', label: 'Oppose' }
    ]
  },
  {
    id: 'yes-no',
    name: 'Yes/No Question',
    description: 'Simple binary choice',
    icon: CheckSquare,
    type: 'single_select',
    question: 'Your question here',
    required: false,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
      { value: 'unsure', label: 'Unsure' }
    ]
  },
  {
    id: 'nps-score',
    name: 'NPS Score',
    description: '0-10 satisfaction rating',
    icon: AnalyticsIcon,
    type: 'nps',
    question: 'How likely are you to recommend this to others?',
    required: false
  },
  {
    id: 'multiple-choice',
    name: 'Multiple Choice',
    description: 'Select from options',
    icon: CheckSquare,
    type: 'single_select',
    question: 'Please select an option',
    required: false,
    options: [
      { value: 'option1', label: 'Option 1' },
      { value: 'option2', label: 'Option 2' },
      { value: 'option3', label: 'Option 3' }
    ]
  },
  {
    id: 'open-feedback',
    name: 'Open-Ended Feedback',
    description: 'Long text response',
    icon: MessageSquare,
    type: 'long_text',
    question: 'Please share your thoughts',
    placeholder: 'Your feedback here...',
    required: false
  },
  {
    id: 'email-collection',
    name: 'Email Collection',
    description: 'Collect email address',
    icon: Mail,
    type: 'email',
    question: 'What is your email address?',
    placeholder: 'email@example.com',
    required: false
  },
  {
    id: 'numeric-input',
    name: 'Numeric Input',
    description: 'Number response',
    icon: Hash,
    type: 'numeric',
    question: 'Enter a number',
    placeholder: '0',
    required: false
  },
  {
    id: 'date-picker',
    name: 'Date Selection',
    description: 'Pick a date',
    icon: Calendar,
    type: 'date',
    question: 'Select a date',
    required: false
  }
];

